import React, { useEffect, useState } from 'react'
import FilterButton from '../../../components/atoms/formFields/buttons/filterButton'
import TopRightLink from '../../../components/atoms/formFields/buttons/topRightLink'
import CardWrapper from '../../../components/molecules/CardWrapper'
import CardHeader from '../../../components/atoms/cardHeader'
import SellerProductTable from './components/SellerProductTable'
import { useDispatch, useSelector } from 'react-redux'
import { GetApprovalRequests } from '../../../store/thunks/productThunk'
import SellerProductFilter from './components/SellerProductFilter'
import { Pagination } from '../../../components/atoms/pagination'
import TableLoader from '../../../components/atoms/Loader/tableLoader'

const TrackApprovalRequests = () => {
  const dispatch = useDispatch();
  const { list, pageInfo, loading } = useSelector((state) => state?.approvalRequests);
  const [approvalPagination, setApprovalPagination] = useState({
    paginationFilter: {
      offset: 0,
      limit: 10,
      order: "DESC",
    },
  });

  useEffect(() => {
    dispatch(GetApprovalRequests({ payload: approvalPagination }))
  }, [approvalPagination])

  return (
    <div className="content d-flex flex-column flex-column-fluid">
      <div className="container">
        <div className="align-items-center d-flex justify-content-end pb-6">
          <FilterButton target={"filter2"} />
          <TopRightLink
            url="/requestNewProduct"
            name="Add Product"
          />
        </div>
      </div>

      <SellerProductFilter approvalPagination={approvalPagination} setApprovalPagination={setApprovalPagination} />

      <CardWrapper>
        <CardHeader name="Track Approval Requests"  tooltipText={"Track status and updates of your product approval requests."}/>
        <div className="card-body p-4">
          {loading ? <TableLoader/> : <SellerProductTable approvalPagination={approvalPagination} approvalList={list} />}
          <Pagination
            pageInfo={pageInfo}
            offset={approvalPagination?.paginationFilter?.offset}
            setOffset={(newOffset) =>
              setApprovalPagination((prev) => ({
                ...prev,
                paginationFilter: {
                  ...prev.filters,
                  offset: newOffset,
                },
              }))
            }
          />
        </div>
      </CardWrapper>
    </div>
  )
}

export default TrackApprovalRequests
